module.exports = __webpack_public_path__ + "static/media/75.f61bc786.jpg";